module.exports = __webpack_public_path__ + "assets/img/address.b4575a7e.png";